export const workspaceAdapter = workspace => ({
  id: workspace.id,
  name: workspace.name,
  description: workspace.description,
  rootFolder: workspace.root_folder,
  apiKey: workspace.api_key,
  profiles: workspace.profiles
})
